import Component from '@glimmer/component';

const STATUS_COLORS = {
  connected: 'cilantro',
  disconnected: 'pistachio',
};

const STATUS_ICONS = {
  connected: 'ui-checkmark',
  disconnected: 'ui-exclamation',
};

/**
 * @param {string} status - the status of the tenant
 */
export default class DiplomatClientConnectionStatusComponent extends Component {
  get statusKey() {
    return (this.status || '').toLowerCase();
  }

  get status() {
    return this.args.status === true ? 'connected' : 'disconnected';
  }

  get color() {
    return STATUS_COLORS[this.statusKey];
  }

  get icon() {
    return STATUS_ICONS[this.statusKey];
  }

  get text() {
    return this.status?.split('_').join(' ');
  }
}
